export default {"src":"https://cdn.sa-tech.de/homeone/main/_next/static/media/flag-belgium.400f4b5a.svg","height":20,"width":30,"blurWidth":0,"blurHeight":0};